import axios from 'axios'

/** Axios-style error with optional response body from our API */
export interface ApiErrorBody {
  response?: {
    data?: { error?: { message?: string } };
    status?: number;
  };
  message?: string;
}

export function getApiErrorMessage(error: unknown, fallback: string): string {
  const e = error as ApiErrorBody;
  return e?.response?.data?.error?.message ?? (error instanceof Error ? error.message : fallback);
}

// In development, always use relative `/api` (Vite proxy handles it).
// In production, use VITE_API_URL if set, otherwise same-origin `/api`.
const API_URL = import.meta.env.PROD
  ? (import.meta.env.VITE_API_URL || '/api')
  : '/api'

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth-storage')
      ? JSON.parse(localStorage.getItem('auth-storage')!).state?.token
      : null
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('auth-storage')
      window.location.href = '/login'
    }
    
    return Promise.reject(error)
  }
)
